module.exports = __webpack_public_path__ + "img/details-health.328a88fb.png";